import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

export type DbMember = {
  id: string;
  name: string;
  team: 'black' | 'white';
  goal: string;
  joined_at: number;
  created_at: string;
};

export type DbScores = {
  id: string;
  black_battle: number;
  black_chemistry: number;
  black_dream_coins: number;
  white_battle: number;
  white_chemistry: number;
  white_dream_coins: number;
  history: unknown[];
  updated_at: string;
};

export type DbTeamMottos = {
  id: string;
  black: string;
  white: string;
  updated_at: string;
};
